import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import UseEvent from 'lb-store/src/hooks/useEvent';
import { OTPModal } from '../Modal/OTP/OTPModal';
import { SignInModal } from '../Modal/SignIn/SignInModal';
import { ResultModal } from '../Modal/Result/ResultModal';
import { SecurityModal } from '../Modal/SecurityModal/SecurityModal';
import { RecoveryModal } from '../Modal/RecoveryModal/RecoveryModal';
import { ChangePasswordModal } from '../Modal/ChangePasswordModal/ChangePasswordModal';
import { GameDepositModal } from '../Modal/GameDeposit/GameDepositModal';
import { LbModal } from 'lb-components';
import { RegisterModal } from '../Modal/RegisterModal/RegisterModal';
import { VerificationModal } from '../Modal/VerificationModal/VerificationModal';
import { PhoneVerificationModal } from '../Modal/PhoneVerificationModal/PhoneVerificationModal';
import { UsePhoneVerification, UseUser } from 'lb-store/src/hooks';
import { useTranslation } from 'lb-store/src/helpers/i18n';

const eventRoot = document.getElementById('lb-events');
let counter = 0;
const Events = () => {
  const event = UseEvent();
  const [eventMap, setEventMap] = useState([]);
  useEffect(() => {
    const listener = event.subscribe('lb-event', eventHandler);
    return () => {
      listener.unsubscribe();
    };
  }, []);

  const eventHandler = (e) => {
    let timestamp = new Date().getTime();
    counter += 1;
    eventMap.push({
      key: timestamp,
      sort: counter,
      component: componentHandler({ event: e, key: timestamp }),
    });
    setEventMap([...eventMap]);
  };
  const componentHandler = ({ event, key }) => {
    switch (event.type) {
      case 'OTP':
        return (
          <OTPModal
            onSuccess={event?.onSuccess}
            onResend={event?.onResend}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'SignIn':
        return (
          <SignInModal
            onSuccess={event?.onSuccess}
            key={key}
            id={counter}
            onCancel={(e) => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
              if (event?.onCancel) event.onCancel(e);
            }}
          />
        );
      case 'Register':
        return (
          <RegisterModal
            onSuccess={event?.onSuccess}
            isReferral={event.isReferral ? event.isReferral : false}
            initialData={event?.initialData}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
              if(event?.onCancel) event.onCancel();
            }}
          />
        );
      case 'ChangePassword':
        return (
          <ChangePasswordModal
            onSuccess={event?.onSuccess}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'SecurityCode':
        return (
          <SecurityModal
            onSuccess={event?.onSuccess}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'Result':
        return (
          <ResultModal
            containerStyle={event?.containerStyle}
            header={event?.header}
            message={event?.message}
            onSuccess={event?.onSuccess}
            onReject={event?.onReject}
            actionLabel={event?.actionLabel}
            cancelLabel={event?.cancelLabel}
            backdropDismiss={event?.backdropDismiss}
            size={event?.size}
            footer={event?.footer}
            key={key}
            id={counter}
            footerComponent={event?.footerComponent}
            bodyComponent={event?.bodyComponent}
            onCancel={(e=null) => {
              if (event?.onCancel) event.onCancel(e);
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'Recovery':
        return (
          <RecoveryModal
            onSuccess={event?.onSuccess}
            message={event?.message}
            key={key}
            id={counter}
            initialTab={event?.initialTab}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'Verification':
        return (
          <VerificationModal
            onSuccess={event?.onSuccess}
            referralId={event?.referralId}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'PhoneVerification':
        return (
          <PhoneVerificationModal
            onSuccess={event?.onSuccess}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
            }}
          />
        );
      case 'GameDeposit':
        return (
          <GameDepositModal
            onSuccess={event?.onSuccess}
            balance={event?.balance}
            platform={event?.platform}
            depositType={event?.depositType}
            secondBalance={event?.secondBalance}
            key={key}
            id={counter}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
              if (event?.onCancel) event.onCancel();
            }}
          />
        );
      case 'Frame':
        return (
          <LbModal
            show={true}
            container={document.getElementById('lb-events')}
            onCancel={() => {
              let findIndex = eventMap.findIndex((v) => v.key === key);
              eventMap.splice(findIndex, 1);
              setEventMap([...eventMap]);
              event?.onCancel();
            }}
            centered={true}
            outsideDismiss={event.outsideDismiss}
            closeButton={event.closeButton}
            variant={event?.variant}
            size={event?.size}
            fullscreen={event?.fullscreen}
            callback={event?.callback}
            frameListener={event?.frameListener}
            content={event?.content}
            style={event?.style}
          >
            {event.children}
          </LbModal>
        );
    }
    return null;
  };
  return ReactDOM.createPortal(
    eventMap.map((v) => v.component),
    eventRoot
  );
};
export default Events;
